module.exports = __webpack_public_path__ + "static/media/right-mark-icon.fbd86fe2.svg";